import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {DiscountSearchModel} from "../discount-search.model";
import {DiscountSearchPageComponent} from "../discount-search-page/discount-search-page.component";
import {DiscountEditPageComponent} from "../discount-edit-page/discount-edit-page.component";
import {
    AbstractSingleSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-single-select-edit-control.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";

@Component({
    selector: "wbo-discount-single-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/single-select-edit-control.component.html",
    providers: [
        registerSelectEditControl(DiscountSingleSelectEditControlComponent),
        provideSearchModel(DiscountSearchModel)
    ]
})
export class DiscountSingleSelectEditControlComponent extends AbstractSingleSelectEditControlComponent<DiscountSearchModel> {
    constructor(model: DiscountSearchModel, injector: Injector) {
        super(model, injector, "discountId", "name");

        this.extendedSearchComponent = DiscountSearchPageComponent;
        this.extendedEditComponent = DiscountEditPageComponent;
    }
}
